import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocaleStrings from "@language";
import { classNames } from "@basecomponent";
import moment from "moment";
import { TicketIcon } from "@heroicons/react/outline";
import { BASE_IMAGES_URL, APP_API_KEY, convertDateIntoLocal } from "@constant";
import { downloadInvoice } from "@transactionaction";
import InvoiceIcon from "../../../assets/image/ticket.svg";
import { ClassicSpinner } from "react-spinners-kit";

const ItemList = (props) => {
  const navigate = useNavigate();

  var { session, listitem, currentTab, myProfile, conversionRate } = props;
  const [loading, setLoading] = useState(false);
  const [tranid, setTranid] = useState(null);
  //console.log("myProfile", myProfile);

  const download_file = (response) => {
    let fileName = response.filename;
    let fileURL = BASE_IMAGES_URL + "/" + fileName + "?api_key=" + APP_API_KEY;

    // for non-IE
    if (!window.ActiveXObject) {
      var save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = fileName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        var evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    } else if (!!window.ActiveXObject && document.execCommand) {
      var _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, fileName || fileURL);
      _window.close();
    }
    setTranid(null);
  };

  const downloadResult = (e) => {
    let methodtobecall = "generate_invoice";
    setLoading(true);
    setTranid(listitem.transactionid);
    props.downloadInvoice(
      session,
      listitem.transactionid,
      methodtobecall,
      (response) => {
        setLoading(false);
        if (response.success === 0) {
        } else {
          download_file(response);
        }
      }
    );
  };

  let tokenamount = 1;
  if (
    conversionRate &&
    conversionRate.length > 0 &&
    conversionRate[0]["tokenamount"]
  ) {
    tokenamount = conversionRate[0]["tokenamount"];
  }

  let transactionfreetoken = listitem.transactionfreetoken;
  transactionfreetoken = Number(transactionfreetoken);
  let transactionpaidtoken = listitem.transactionpaidtoken;
  transactionpaidtoken = Number(transactionpaidtoken);
  let transactioncashtoken = listitem.transactioncashtoken;
  transactioncashtoken = Number(transactioncashtoken);

  let token = Math.max(transactionpaidtoken, transactioncashtoken);

  let totalpaid =
    parseInt(listitem.transactionpaidtoken) +
    parseInt(listitem.transactioncashtoken) +
    parseInt(listitem.transactionfreetoken);
  totalpaid = (totalpaid * tokenamount).toFixed(2);
  let transactionamount = Number(listitem.transactionamount);
  transactionamount = transactionamount.toFixed(2);
  return (
    <tr className="bg-white border-b">
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-medium text-primary">
            {convertDateIntoLocal(listitem.createdon).format(
              "DD-MM-YYYY HH:mm"
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div className="text-sm font-medium text-primary">
            Txn - {listitem.transactioncode}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-medium text-primary">
            &euro;
            {currentTab == "spent"
              ? totalpaid.replace(".", ",")
              : transactionamount.replace(".", ",")}
          </div>
        </div>
      </td>
      {currentTab == "bought" ? (
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex items-center">
            <div className="text-sm font-medium text-primary">
              &euro;
              {(token * tokenamount).toFixed(2).replace(".", ",")}
            </div>
          </div>
        </td>
      ) : (
        ""
      )}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-medium text-primary">
            {currentTab == "spent"
              ? listitem.servicename + " - " + listitem.devicename
              : "\u20AC" +
                (transactionfreetoken * tokenamount)
                  .toFixed(2)
                  .replace(".", ",")}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div
            className={classNames(
              currentTab == "spent"
                ? listitem.isbadge == "1"
                  ? "rounded border border-badge text-badge p-2"
                  : "rounded border border-numberplate p-2 text-numberplate"
                : "text-primary",
              "text-sm font-medium"
            )}
            text-sm
          >
            {currentTab == "spent"
              ? listitem.exnumberplate
                ? listitem.exnumberplate
                : listitem.numberplate
              : listitem.paymode}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-medium text-primary">
            {currentTab == "spent"
              ? listitem.exreference
                ? listitem.exreference
                : listitem.reference
              : convertDateIntoLocal(listitem.validuntil).format(
                  "DD-MM-YYYY HH:mm"
                )}
          </div>
        </div>
      </td>
      {currentTab == "bought" ? (
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex items-center">
            <div
              className="text-sm font-medium text-primary cursor-pointer "
              onClick={(e) => downloadResult(e)}
            >
              {tranid == listitem.transactionid ? (
                <ClassicSpinner
                  size={20}
                  color="var(--theme-color)"
                  loading={true}
                />
              ) : listitem.invoice_nr || listitem.ticket_nr ? (
                listitem.invoice_nr ? (
                  <img src={InvoiceIcon} className="h-5 w-5" />
                ) : (
                  <TicketIcon className="h-6 w-6" />
                )
              ) : myProfile && myProfile.iscompanyhr ? (
                <img src={InvoiceIcon} className="h-5 w-5" />
              ) : (
                <TicketIcon className="h-6 w-6" />
              )}
            </div>
          </div>
        </td>
      ) : (
        ""
      )}
    </tr>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
    myProfile: state.myProfile.data,
    conversionRate: state.conversionRate.data,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ downloadInvoice }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemList);
